const companyLicenseActionTypes = {
  COMPANY_LICENSE_FETCH_REQUEST: 'COMPANY_LICENSE_FETCH_REQUEST',
  COMPANY_LICENSE_SET_DATA: 'COMPANY_LICENSE_SET_DATA',
  COMPANY_LICENSE_SET_ERROR: 'COMPANY_LICENSE_SET_ERROR',
  REMOVE_LICENSE_DETAILS: 'REMOVE_LICENSE_DETAILS',
  BOT_SUBSCRIPTION_FETCH_REQUEST: 'BOT_SUBSCRIPTION_FETCH_REQUEST',
  BOT_SUBSCRIPTION_SET_DATA: 'BOT_SUBSCRIPTION_SET_DATA',
  BOT_SUBSCRIPTION_SET_ERROR: 'BOT_SUBSCRIPTION_SET_ERROR',
};

export default companyLicenseActionTypes;
